import ReactGA from 'react-ga';

const GOOGLE_ANALYTICS_PROD_ID = 'UA-17280998-1';
const GOOGLE_ANALYTICS_TEST_ID = 'UA-17280998-11';
const GA_TRACKING_ENV = ['eu', 'production', 'test'];

const getStepTrackingPath = (stepIndex, isSuccess) => {
	if (isSuccess) {
		return '/self_service_success';
	}

	switch (stepIndex) {
		case 0:
			return '/self_service_email_page';
		case 1:
			return '/self_service_confirmation_code';
		case 2:
			return '/self_service_set_password';
		case 3:
			return '/self_service_set_user_details';
		case 4:
			return '/self_service_account_settings';
		default:
			return null;
	}
};

const getGoogleAnalyticsId = () => {
	if (['production', 'eu'].includes(process.env.NODE_ENV)) {
		return GOOGLE_ANALYTICS_PROD_ID;
	}

	return GOOGLE_ANALYTICS_TEST_ID;
};

export const GOOGLE_ANALYTICS_ID = getGoogleAnalyticsId();

export const isGoogleAnalyticsEnabled = GA_TRACKING_ENV.includes(process.env.NODE_ENV);

export const gaPageView = (stepIndex, isSuccess) => {
	const pagePath = getStepTrackingPath(stepIndex, isSuccess);
	if (isGoogleAnalyticsEnabled) {
		ReactGA.pageview(pagePath);
	}
};

const TAG_MANAGER_IFRAME_SRC_TEST =
	'https://www.googletagmanager.com/ns.html?id=GTM-NDC72N&gtm_auth=3yMB_Fs3oWg8oG8G65l6wA&gtm_preview=env-166&gtm_cookies_win=x';
const TAG_MANAGER_IFRAME_SRC_PROD = 'https://www.googletagmanager.com/ns.html?id=GTM-NDC72N';
const TAG_MANAGER_SCRIPT_TEST = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl+ '&gtm_auth=3yMB_Fs3oWg8oG8G65l6wA&gtm_preview=env-166&gtm_cookies_win=x';f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-NDC72N');`;
const TAG_MANAGER_SCRIPT_PROD =
	"(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-NDC72N');";

const addGoogleTagMangerByEnv = () => {
	const iframeSrc = ['production', 'eu'].includes(process.env.NODE_ENV)
		? TAG_MANAGER_IFRAME_SRC_PROD
		: TAG_MANAGER_IFRAME_SRC_TEST;
	const scriptCode = ['production', 'eu'].includes(process.env.NODE_ENV)
		? TAG_MANAGER_SCRIPT_PROD
		: TAG_MANAGER_SCRIPT_TEST;

	const script = document.createElement('script');
	script.innerHTML = scriptCode;
	script.id = 'google-tag-manager-head';
	document.head.appendChild(script);

	const noScript = document.createElement('noscript');
	const iframe = document.createElement('iframe');
	iframe.setAttribute('id', 'google-tag-manager-body');
	iframe.setAttribute('src', iframeSrc);
	iframe.setAttribute('height', '0');
	iframe.setAttribute('width', '0');
	iframe.setAttribute('style', 'display:none;visibility:hidden');
	noScript.appendChild(iframe);
	document.body.appendChild(noScript);
};

const GoogleAnalytics = ({ applicationId }) => {
	if (isGoogleAnalyticsEnabled) {
		ReactGA.initialize(applicationId);
		addGoogleTagMangerByEnv();
	}
	return null;
};

export const SIGNUP_METHOD_TYPES = { STANDARD: 'standard', SSO: 'sso' };
export const getStepEvent = (stepIndex, isSuccess, signUpMethod, isFreeTrial) => {
	if (isSuccess) {
		return { event: 'account_registration_complete', method: signUpMethod, isFreeTrial };
	}

	switch (stepIndex) {
		case 1:
			return { event: 'account_registration_start', method: signUpMethod };
		default:
			return null;
	}
};

export const gaPushEvent = ({ stepIndex, isSuccess, signUpMethod, isFreeTrial }) => {
	if (!isGoogleAnalyticsEnabled) {
		return;
	}
	const event = getStepEvent(stepIndex, isSuccess, signUpMethod, isFreeTrial);
	if (event && window.dataLayer) {
		window.dataLayer.push(event);
	}
};

export default GoogleAnalytics;
